import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import queryString from 'querystring';

import { AppContext } from '@prisjakt/ui-app-context';
import { bemGenerator } from '@prisjakt/ui-base';
import ArrowIcon from 'mdi-react/ChevronRightIcon';
import './show-all.scss';

const styles = bemGenerator('pj-ui-search-show-all', []);

const getQueryString = history =>
  queryString.decode(history.location.search.substr(1));

const getLink = (query, history) => {
  const qs = getQueryString(history);

  qs.q = query;
  delete qs.search;

  const qsEncoded = queryString.encode(qs);
  return `/search?${qsEncoded}`;
};

const ShowAll = ({ onClick, styling, query, history }) => {
  const { t } = useContext(AppContext);
  return (
    <Link
      onClick={onClick}
      className={styles.block.withModifier({ [styling]: true })}
      to={getLink(query, history)}
    >
      <span>{t('search', 'results.show-all-button')}</span>
      <ArrowIcon right />
    </Link>
  );
};

const { string, func, object } = PropTypes;

ShowAll.propTypes = {
  query: string.isRequired,
  styling: string.isRequired,
  history: object.isRequired,
  onClick: func,
};

ShowAll.defaultProps = {
  onClick: () => {},
};

export default memo(withRouter(ShowAll));
